import {
    Box, 
    Paper, Typography, useTheme,        
    FormControl,
    Select,
    MenuItem,    
    InputLabel,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import clsx from 'clsx';
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService, tipoConfronto } from "../../shered/services/api/utilidades/UtilidadesService";
import {  IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";

import { EstatisticasService, IListaDadosMediaTimes } from "../../shered/services/api/estatisticas/EstatisticasService";
import { DataGrid, GridCellParams, GridColDef } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";

const lstQtdRodadasFiltro = [
    {
        codigo: 5,
        label: "5"
    },
    {
        codigo: 10,
        label: "10"
    },
    {
        codigo: 15,
        label: "15"
    },
    {
        codigo: 20,
        label: "20"
    },
    {
        codigo: 25,
        label: "25"
    },
    {
        codigo: 30,
        label: "30"
    },
    {
        codigo: 35,
        label: "35"
    },
    {
        codigo: 40,
        label: "40"
    },
    {
        codigo: 45,
        label: "45"
    },
    {
        codigo: 50,
        label: "50"
    }
    ,
    {
        codigo: 100,
        label: "100"
    }
];

const columnsGeral: GridColDef[] = [
    {
        field: 'codigo',
        headerName: '',
        flex: 1,
        minWidth: 58,
        maxWidth: 58,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',


    }, {
        field: 'caminho_Logo',
        headerName: 'LOGO',
        editable: false,
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 35 : 65,
        maxWidth: UtilidadeService.isMobile() ? 35 : 65,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => params.value !== null ? <img src={params.value} width={UtilidadeService.isMobile() ? 25 : 45} height={UtilidadeService.isMobile() ? 30 : 50} /> : null,
    },
    {
        field: 'nome',
        headerName: 'FRANQUIA',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ? false : true ,
        minWidth: UtilidadeService.isMobile() ? 115 : 250,
        headerClassName: 'super-app-theme--header'
    },

    {
        field: 'quantidade_Jogos',
        headerName: 'QTD',
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        editable: false,
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'min',
        headerName: 'MIN',
        editable: false,
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: 60,
        maxWidth: 60,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'fgm',
        headerName: 'FGM',
        editable: false,
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: 60,
        maxWidth: 60,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'threepm',
        headerName: '3PTS',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"


    },
    {
        field: 'pts',
        headerName: 'PTS',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth:UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"


    },
    {
        field: 'reb',
        headerName: 'REB',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'oreb',
        headerName: 'OREB',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'dreb',
        headerName: 'DREB',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'ast',
        headerName: 'AST',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'stl',
        headerName: 'STL',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'blk',
        headerName: 'BLK',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'to',
        headerName: 'TO',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'pf',
        headerName: 'PF',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'mplu',
        headerName: 'MPLU',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        cellClassName: (params: GridCellParams<any, number>) => {

            if (params.value == null) {

                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : 0
    },
    {
        field: 'fgmp',
        headerName: 'FGM%',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'ftmp',
        headerName: 'FTM%',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'threepmp',
        headerName: '3P%',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'fte',
        headerName: 'FTE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',       
        renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },
    {
        field: 'fge',
        headerName: 'FGE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',       
        renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },        
    {
        field: 'threepe',
        headerName: '3PE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',        
        renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },
    {
        field: 'stocks',
        headerName: 'STOCKS',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:  UtilidadeService.isMobile() ?false : true ,
        minWidth: UtilidadeService.isMobile() ? 50 : 80,
        maxWidth: UtilidadeService.isMobile() ? 50 : 80,
        align: 'center',
        headerAlign: 'center',        
        renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },
];

export const ListagemDeMediaTimes: React.FC = () => {
    const theme = useTheme();
    //const refTab = useRef<any>(null);
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    //const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    //const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [estatisticasRows, setEstatisticasRows] = useState<IListaDadosMediaTimes[]>([]);    
    const [temporadaFiltro, setTemporadaFiltro] = useState(0);
    const [tipoConfrontoFiltro, setTipoConfrontoFiltro] = useState(1);
    const [qtdRodadasFiltro, setQtdRodadasFiltro] = useState(5);
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    }); 


    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                    .then((result) => {
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;

                    });

                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setShowImagemFranquia(liga.caminho_Logo);
                        }
                        setTemporadaFiltro(liga.codigo_Temporada);
                        carregarDadosTimes(liga.codigo_Temporada, qtdRodadasFiltro, tipoConfrontoFiltro);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }

                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });
            })
        }
    }, []);

    const carregarDadosTimes = (codigoTemporada: number, qtdJogos: number, tipoConfronto: number) => {
        setIsLoading(true);
        setRemoveLoading(false);

        EstatisticasService.getMediaTimes(Number(codigoLiga), codigoTemporada, qtdJogos, tipoConfronto)
            .then((result) => {
                const lstDados = result.dado;           
                setEstatisticasRows(lstDados.sort((a, b) => a.nome > b.nome ? 1 : -1));
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }   

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        setTemporadaFiltro(e.target.value);
        setEstatisticasRows([]);
        if (Number(e.target.value) > 0) {
            carregarDadosTimes(Number(e.target.value), qtdRodadasFiltro, tipoConfrontoFiltro);
        }
    }

    const handleQuantidadeRodadas = async (e: { target: { name: string; value: any; }; }) => {
        setQtdRodadasFiltro(e.target.value);
        setEstatisticasRows([]);
        if (Number(e.target.value) > 0) {
            carregarDadosTimes(temporadaFiltro, Number(e.target.value), tipoConfrontoFiltro);
        }
    }

    const handleTipo = async (e: { target: { name: string; value: any; }; }) => {
        setTipoConfrontoFiltro(e.target.value);
        setEstatisticasRows([]);
        if (Number(e.target.value) > 0) {
            carregarDadosTimes(temporadaFiltro, qtdRodadasFiltro, Number(e.target.value));
        }
    }


    return (
        <LayoutBaseDePagina
            titulo={`Média Times - ${dadosLiga?.nome}`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{xs:12, sm:12}} sx={{ width: "100%" }}>
                    <Grid container size={{xs:12, sm:12}}direction="column" padding={2} spacing={2} >
                        <Grid container size={{xs:12, sm:12}}spacing={1}>
                            <Grid  size={{xs:12, sm:12}} >
                                <Typography variant="h6"> Média dos Times </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="initial" spacing={2}>
                                <Grid  size={{xs:12, sm:6, md:3}} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={temporadaFiltro}
                                            label="Temporadas"
                                            onChange={(handleSelectedTemporada)}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid  size={{xs:12, sm:3,md:3}} display="flex" justifyContent="center">
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Quantidade Rodadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={qtdRodadasFiltro}
                                            label="Quantidade Rodadas"
                                            onChange={handleQuantidadeRodadas}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstQtdRodadasFiltro.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid  size={{xs:12, sm:6, md:3}} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={tipoConfrontoFiltro}
                                            label="Tipo Confronto"
                                            onChange={handleTipo}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                tipoConfronto.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                            </Grid>
                            <Grid  size={{xs:12, sm:12}}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid  size={{xs:12, sm:12}}  >
                                {estatisticasRows.length > 0 && (
                                    <Box sx={{
                                        height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                        '& .super-app-theme--header': {
                                            backgroundColor: theme.palette.common.black,
                                            color: theme.palette.common.white,
                                            //position: "fixed"
                                        },
                                        '& .super-app.negative': {
                                            color: 'red',
                                            fontWeight: 'bold'
                                        },
                                        '& .super-app.positive': {
                                            color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                            fontWeight: '600',
                                        },
                                        '& .super-app-theme--cell': {
                                            color: '#00e676',
                                            fontWeight: '600',
                                        },
                                        '& .MuiDataGrid-main':{
                                            height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                            overflow:UtilidadeService.isMobile() ? "overlay" : "hidden",
                                        },
                                        '& .MuiDataGrid-columnHeaders ':{
                                            //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                            zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                        }
                                    }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.codigo}
                                            rows={estatisticasRows}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 24,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                codigo: false,
                                                ast: estatisticasRows.filter(f => f.ast === null).length === 0,
                                                blk: estatisticasRows.filter(f => (f.blk === null)).length === 0,
                                                dreb: estatisticasRows.filter(f => (f.dreb === null)).length === 0,
                                                fga: estatisticasRows.filter(f => (f.fga === null)).length === 0,
                                                fgm: estatisticasRows.filter(f => f.fgm === null).length === 0,
                                                fgmp: estatisticasRows.filter(f => (f.fgmp === null)).length === 0,
                                                fta: estatisticasRows.filter(f => (f.fta === null)).length === 0,
                                                ftm: estatisticasRows.filter(f => (f.ftm === null)).length === 0,
                                                ftmp: estatisticasRows.filter(f => (f.ftmp === null)).length === 0,
                                                min: estatisticasRows.filter(f => (f.min === null)).length === 0,
                                                mplu: estatisticasRows.filter(f => (f.mplu === null)).length === 0,
                                                oreb: estatisticasRows.filter(f => (f.oreb === null)).length === 0,
                                                pf: estatisticasRows.filter(f => (f.pf === null)).length === 0,
                                                pts: estatisticasRows.filter(f => (f.pts === null)).length === 0,
                                                reb: estatisticasRows.filter(f => (f.reb === null)).length === 0,
                                                stl: estatisticasRows.filter(f => (f.stl === null)).length === 0,
                                                threepa: estatisticasRows.filter(f => (f.threepa === null)).length === 0,
                                                threepm: estatisticasRows.filter(f => (f.threepm === null)).length === 0,
                                                threepmp: estatisticasRows.filter(f => (f.threepmp === null)).length === 0,
                                                to: estatisticasRows.filter(f => (f.to === null)).length === 0,
                                                fge: estatisticasRows.filter(f => (f.fge === null || f.fge === undefined)).length === 0,
                                                fte: estatisticasRows.filter(f => (f.fte === null || f.fte === undefined)).length === 0,
                                                threepe: estatisticasRows.filter(f => (f.threepe === null || f.threepe === undefined)).length === 0,
                                                stocks: estatisticasRows.filter(f => (f.stocks === null || f.stocks === undefined)).length === 0,
                                            }}
                                            disableDensitySelector
                                            disableVirtualization
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            pageSizeOptions={[24, 50, 100]}
                                            disableRowSelectionOnClick
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ? 11 : 16,
                                            }}                                            

                                        />
                                    </Box>
                                )}                             
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}


